import React from "react";
import { Modal, Box, Typography, Button, CircularProgress } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Link } from "react-router-dom"; 

const SuccessModal = ({ isOpen, handleClose, invoice, emailLoader }) => {
  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="success-modal">
      <Box
        className="d-flex flex-column align-items-center justify-content-center"
        sx={{
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          p: 4,
          maxWidth: 400,
          margin: "auto",
          textAlign: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {/* Loading Spinner or Sending Animation */}
        {emailLoader ? (
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex justify-content-center mb-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Sending...</span>
              </div>
            </div>
            <Typography variant="h6" color="text.secondary">
              Sending your invoice...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please wait while we send the email to {invoice?.buyer?.contact?.email}.
            </Typography>
          </div>
        ) : (
          <>
            <CheckCircleOutlineIcon
              sx={{ fontSize: 64, color: "green", mb: 2 }}
            />
            <Typography variant="h5" className="mb-3">
              Email Sent Successfully!
            </Typography>
            <EmailOutlinedIcon sx={{ fontSize: 48, color: "#1976d2", mb: 3 }} />
            <Typography variant="body1" className="mb-4">
              Your invoice has been sent to <strong>{invoice?.buyer?.contact?.email}</strong>.
            </Typography>
          </>
        )}

        {/* Links */}
        <div className="d-flex flex-column gap-2">
          <Link to="/" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              className="w-100"
              onClick={handleClose}
              disabled={emailLoader}
            >
              Go to Dashboard
            </Button>
          </Link>
          <Link to="/app/list-invoices" style={{ textDecoration: "none" }}>
            <Button
              variant="outlined"
              className="w-100"
              onClick={handleClose}
              disabled={emailLoader}
            >
              View Invoice List
            </Button>
          </Link>
          <Link to="/app/invoice-generator" style={{ textDecoration: "none" }}>
            <Button
              variant="outlined"
              className="w-100"
              onClick={handleClose}
              disabled={emailLoader}
            >
              Create New Invoice
            </Button>
          </Link>
        </div>
      </Box>
    </Modal>
  );
};

export default SuccessModal;
